import React from 'react';
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const ItemToken = ({item, className = ""}) => {
    return (
        <>
            {
                item.img &&
                <img className={item.key === "sos" ? "w-4.5" :"w-5.5"} src={getAssetPath(`img/dashboard-svg/${item.img }`)} alt=""/>
            }

            {
                item.icon &&
                <i className="sw icon-sw-attendance text-[16px] text-[#031b34]"></i>
            }

            {
                !item?.icon && !item?.img &&
                <span
                    className={["flex shrink-0 items-center justify-center rounded-[5px] font-mono text-white leading-none", className].join(" ")}
                    style={{width: 22, height: 22, background: item.color, fontSize: 9}}
                >
                    {item.code}
                </span>
            }
        </>
    );
};

export default ItemToken;
